<template>
    <div class="md-layout-item md-size-100">
        <modal v-if="showModal" @close="modalHide">
            <template slot="header">
                <h4 class="modal-title">{{ $t("add_staff") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="modalHide"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <md-card>
                    <md-card-header
                        class="md-card-header-icon md-card-header-green"
                    >
                        <div class="card-icon">
                            <md-icon>person</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout-item md-size-100">
                            <form ref="form" id="staffForm">
                                <form-builder
                                    ref="formulario"
                                    @on-validated="onFormValidated"
                                    :value="this.item"
                                    :model="datosFormulario"
                                    :schema="this.formData"
                                >
                                </form-builder>
                                <!--
                                <staff-form
                                        @on-validated="onFormValidated"
                                        ref="formulario"
                                        :usuario.sync="item"
                                    >
                                    </staff-form>
                                -->
                            </form>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button class="md-danger md-simple" @click="modalHide">{{$t("cancel")}}</md-button>
                <md-button @click="submit()" class="md-success">{{
                    $t("save")
                }}</md-button>
            </template>
        </modal>

        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                    <md-icon>supervisor_account</md-icon>
                </div>
                <h4 class="title">{{ $t(tableTitle) }}</h4>
                <md-button
                    v-if="permissionsAdminCentro"
                    class="md-success pull-right"
                    @click="openModal(null)"
                    >{{ $t("add_staff") }}</md-button
                >
            </md-card-header>
            <md-card-content>
                <md-table table-header-color="green">
                    <md-table-row>
                        <md-table-head>ID</md-table-head>
                        <md-table-head>{{ $t("username") }}</md-table-head>
                        <md-table-head>{{ $t("name") }}</md-table-head>
                        <md-table-head>{{ $t("language") }}</md-table-head>
                        <md-table-head>{{ $t("role") }}</md-table-head>
                        <md-table-head></md-table-head>
                    </md-table-row>
                    <md-table-row
                        v-for="(data, i) in response.lista"
                        :key="i"
                        slot="md-table-row"
                    >
                        <md-table-cell>{{ data.id }}</md-table-cell>
                        <md-table-cell>{{ data.username }}</md-table-cell>
                        <md-table-cell>{{ data.nombre }}</md-table-cell>
                        <md-table-cell>{{ data.locale }}</md-table-cell>
                        <md-table-cell>{{
                            roleMapping(data.role)
                        }}</md-table-cell>
                        <md-table-cell>
                            <md-button
                                v-if="permissionsAdminCentro"
                                class="md-just-icon md-success"
                                @click="openModal(i)"
                            >
                                <md-icon>edit</md-icon>
                                <md-tooltip md-direction="top">{{
                                    $t("edit")
                                }}</md-tooltip>
                            </md-button>
                            <md-button
                                v-if="permissionsAdminCentro"
                                class="md-just-icon md-danger"
                                @click="deleteItem(data.id)"
                            >
                                <md-icon>close</md-icon>
                                <md-tooltip md-direction="top">{{
                                    $t("delete")
                                }}</md-tooltip>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import Modal from "../Modal";
import formBuilder from "../../formBuilder";
import { EventBus } from '../../helpers/EventBus';

export default {
    name: "staff_list",
    components: {
        Modal,
        formBuilder
    },
    mounted() {
        this.fetchData();
        EventBus.$on('cambio-centro', this.fetchData);
    },
    created(){
        this.setPermissions();
    },
    data() {
        return {
            permissionsAdminCentro: false,
            formValidated: null,
            body: {},
            id: null,
            item: null,
            itemList: [],
            formData: [],
            showModal: false,
            isLoading: false,
            response: {
                lista: []
            },
            datosFormulario: {},
            tableTitle: "staff_management"
        };
    },
    methods: {
         setPermissions() {
            let user = JSON.parse(localStorage.getItem("instantcare_user"));
            if (user.roles.includes("ROLE_CENTRO")) {
                this.permissionsAppQR = false;
                this.permissionsAdminCentro = true;
                this.permissionsAdminCadena = false;
            }
            if (user.roles.includes("ROLE_ENFERMERA")) {
                this.permissionsAppQR = true;
                this.permissionsAdminCentro = false;
                this.permissionsAdminCadena = false;
            }
        },
        destroy() {
            this.formValidated = null;
            this.body = {};
            this.id = null;
            this.item = null;
            this.itemList = [];
            this.formData = [];
            this.response = {};
            this.datosFormulario = {};
        },
        onFormValidated(model) {
            this.datosFormulario = { ...this.datosFormulario, ...model };
        },
        roleMapping: function(role) {
            if (role === "ROLE_CENTRO") {
                return this.$root.$t("center_administrator");
            } else if (role === "ROLE_ENFERMERA") {
                return this.$root.$t("nurse");
            } else {
                return "NO STATUS";
            }
        },
        submit() {
            this.$refs["formulario"].validate().then(res => {
                if (res) {
                    if (!this.item.id) {
                        this.new(this.datosFormulario);
                    } else {
                        this.edit(this.datosFormulario);
                    }
                    this.modalHide();
                }
            });
        },
        edit(data) {
            let self = this;
            fetch(`${BACKEND_API}/api/staff/edit/` + data.id, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify(data)
            })
                .then(handleResponse)
                .then(response => {
                    self.$notify({
                        message: self.$root.$t("user_updated_successfully"),
                        icon: "add_alert",
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: "success"
                    });
                    this.fetchData();
                });
        },
        new(data) {
            let self = this;
            this.id = null;
            fetch(`${BACKEND_API}/api/staff/new`, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify(data)
            })
                .then(handleResponse)
                .then(response => {
                    self.$notify({
                        message: self.$root.$t("user_created_successfully"),
                        icon: "add_alert",
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: "success"
                    });
                    this.fetchData();
                });
        },
        formConfig() {
            fetch(`${BACKEND_API}/api/staff/prepare`, {
                method: "GET",
                headers: authHeader()
            })
                .then(response => response.json())
                .then(data => {
                    this.formData = data[1];
                });
        },
        openModal(id) {
            this.id = id;
            this.item = this.itemList[id];
            if (id === null) {
                this.item = {
                    id: null,
                    locale: 'es',
                    nombre: '',
                    role: 'ROLE_CENTRO',
                    twoFactorEnabled: false,
                    username: ''
                };
            }
            this.datosFormulario = { ...{}, ...this.item };
            this.formConfig();
            this.showModal = true;
        },
        modalHide() {
            this.showModal = false;
        },
        deleteItem(id) {
            let self = this;
            this.$swal({
                title: this.$root.$t("are_you_sure"),
                text: this.$root.$t("you_cannot_revert_the_operation"),
                type: "warning",
                showCancelButton: true,
                closeOnClickOutside: false,
                confirmButtonText: this.$root.$t("yes"),
                cancelButtonText: this.$root.$t("no"),
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-danger",
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(result => {
                if (result.value) {
                    fetch(`${BACKEND_API}/api/staff/baja/` + id, {
                        method: "GET",
                        headers: authHeader()
                    })
                        .then(handleResponse)
                        .then(response => {
                            self.$notify({
                                message: self.$root.$t(
                                    "user_deleted_successfully"
                                ),
                                icon: "add_alert",
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success"
                            });
                            this.fetchData();
                        });
                }
            });
        },
        fetchData() {
            let self = this;
            let url = `${BACKEND_API}/api/staff/list`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = `${BACKEND_API}/api/staff/list?idCentro=${currentCentro.id}`;
            }
            fetch(url, {
                method: "GET",
                headers: authHeader()
            })
                .then(handleResponse)
                .then(response => {
                    self.response = response;
                    this.itemList = response.lista;
                    self.isLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
}

.md-table-row .md-table-cell:last-child {
    text-align: right;
}

.md-table-cell-container .md-button:not(:first-child) {
    margin-left: 3px;
    margin-right: 3px;
}

.md-table-cell-container .md-button:not(:last-child) {
    margin-left: 3px;
    margin-right: 3px;
}
</style>
